import React,  { Component } from "react";


class Pricing extends Component{
    render(){
        return(
            <div className={`pricing-table-area pt--40 pt_sm--100 ${this.props.horizontalpricing}`} id="pricing">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb--40">
                                <h2>PLANES DE <span className="theme-color">SUSCRIPCIÓN</span></h2>
                                <img className="image-1" src={require('../assets/images/app/title-icon-2.png')} alt="App Landing"/>
                                <img className="image-2" src={require('../assets/images/app/title-icon.png')} alt="App Landing"/>
                                <img className="image-3" src={require('../assets/images/app/title-icon-3.png')} alt="App Landing"/>
                                <p>Elige el plan que mejor se adapte a las necesidades de tu operación agrícola. Todas nuestras suscripciones incluyen acceso completo a las herramientas de mapeo y análisis de Mapptrix.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row mt--30">

                        {/* Start Single Pricing */}
                        <div className="col-lg-4 col-md-6 col-12 pricing-column mt--40">
                            <div className="single-price-package">
                                <div className="price-title">
                                    <h3>Básico</h3>
                                    <div className="price">
                                        <h4><span className="text-top">$</span><span className="text-large">55</span></h4>
                                        <p><span className="text-bottom">/mes</span></p>
                                    </div>
                                </div>
                                <div className="price-list">
                                    <ul>
                                        <li>5 Campos</li>
                                        <li>1 Usuario</li>
                                        <li>Mapeo básico</li>
                                        <li>Análisis de suelo</li>
                                        <li>Soporte por email</li>
                                    </ul>
                                    <div className="price-btn">
                                        <button className="button" type="button">Comenzar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End Single Pricing */}

                        {/* Start Single Pricing */}
                        <div className="col-lg-4 col-md-6 col-12 pricing-column mt--40">
                            <div className="single-price-package list-large">
                                <div className="price-title">
                                    <h3>PROFESIONAL</h3>
                                    <div className="price">
                                        <h4><span className="text-top">$</span><span className="text-large">55</span></h4>
                                        <p><span className="text-bottom">/mes</span></p>
                                    </div>
                                </div>
                                <div className="price-list">
                                    <ul>
                                        <li>20 Campos</li>
                                        <li>5 Usuarios</li>
                                        <li>Mapeo avanzado</li>
                                        <li>Reportes detallados</li>
                                        <li>Soporte prioritario</li>
                                    </ul>
                                    <div className="price-btn">
                                        <button className="button" type="button">Comenzar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End Single Pricing */}

                        {/* Start Single Pricing */}
                        <div className="col-lg-4 col-md-6 col-12 pricing-column mt--40">
                            <div className="single-price-package">
                                <div className="price-title">
                                    <h3>EMPRESARIAL</h3>
                                    <div className="price">
                                        <h4><span className="text-top">$</span><span className="text-large">55</span></h4>
                                        <p><span className="text-bottom">/mes</span></p>
                                    </div>
                                </div>
                                <div className="price-list">
                                    <ul>
                                        <li>Campos ilimitados</li>
                                        <li>Usuarios ilimitados</li>
                                        <li>Todas las funciones</li>
                                        <li>API personalizada</li>
                                        <li>Soporte 24/7</li>
                                    </ul>
                                    <div className="price-btn">
                                        <button className="button" type="button">Comenzar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End Single Pricing */}
                    </div>
                </div>
            </div>
        )
    }
}

export default Pricing;













